import {
  req,
  Request
} from '../api/Repository';
import Vue from 'vue'
import uuid from 'uuid/v4';

import axios from 'axios';
const resource = '/user';


export const setFullToken = token => `Bearer ${token}`




let promise = null

export const checkMachineToken = () => {
  let xclientid = "";
  if (localStorage.getItem('xclientid')) {
    xclientid = localStorage.getItem('xclientid')
  } else {
    xclientid = uuid();
    localStorage.setItem('xclientid', xclientid);
  }
  const headers = {
    headers: {
      'X-ClientId': xclientid
    }
  }
  return headers;
}

export const checkTokenHeaders = (token, headers) => {
  const locHeaders = {}
  const now = new Date();
  const {
    bearerToken,
    bearerExpiration,
    refreshExpiration,
    refreshToken
  } = token

  if (now < new Date(bearerExpiration)) {
    return new Promise((res, _) => {
      if (token) {
        headers['headers']['Authorization'] = setFullToken(bearerToken);
      }
      res(headers)
    })
  }

  if (!promise) {
    promise = new Promise((res, rej) => {
      if (now < new Date(refreshExpiration)) {
        req().then(token => {
          Request.post(`${resource}/extendbearertoken`, JSON.stringify({
              bearerToken,
              refreshToken
            })).then(({
              data
            }) => {
              localStorage.setItem('token', JSON.stringify(data));
              if (token) {
                headers['headers']['Authorization'] = setFullToken(data.bearerToken);
              }
              res(headers);
            })
            .catch(err => rej(err))
        })

      } else {
        rej();
      }
    })
    promise.finally(() => promise = null)
  }
  return promise
}
